module.exports = __webpack_public_path__ + "img/icon_star.1d139692.png";